<template>
  <section class="notfound-section">
    <div class="notfound-container">
      <span class="code-tag">Error 404</span>
      <h1 class="notfound-title">This page has moved on</h1>
      <p class="notfound-text">
        The page you were looking for is no longer here, or the link that
        brought you was mistyped. Everything else is exactly where you left it.
      </p>

      <div class="notfound-actions">
        <router-link to="/" class="btn-primary">Back to Home</router-link>
        <router-link to="/contactus" class="btn-outline">Contact Us</router-link>
      </div>

      <div class="notfound-links">
        <p class="links-label">Popular pages</p>
        <ul>
          <li><router-link to="/associatedbuilders">Associated Builders</router-link></li>
          <li><router-link to="/buyer">Buyer Guides</router-link></li>
          <li><router-link to="/about">About Us</router-link></li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script setup></script>

<style scoped>
.notfound-section {
  min-height: 70vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(180deg, #ffffff 0%, #f5f5f5 100%);
  padding: 100px 24px;
  color: #1a1a1a;
}

.notfound-container {
  max-width: 620px;
  text-align: center;
}

.code-tag {
  display: inline-block;
  color: #b91c1c;
  font-weight: 800;
  font-size: 0.85rem;
  letter-spacing: 3px;
  text-transform: uppercase;
  margin-bottom: 16px;
}

.notfound-title {
  font-size: clamp(2rem, 5vw, 3rem);
  font-weight: 800;
  color: #111;
  margin: 0 0 18px;
  line-height: 1.15;
}

.notfound-text {
  font-size: 1.05rem;
  line-height: 1.7;
  color: #555;
  margin: 0 auto 36px;
  max-width: 520px;
}

.notfound-actions {
  display: flex;
  gap: 16px;
  justify-content: center;
  flex-wrap: wrap;
}

.btn-primary,
.btn-outline {
  display: inline-block;
  padding: 14px 30px;
  border-radius: 4px;
  font-weight: 700;
  font-size: 0.95rem;
  letter-spacing: 0.5px;
  text-decoration: none;
  transition: all 0.3s ease;
}

.btn-primary {
  background: #b91c1c;
  color: #fff;
  border: 2px solid #b91c1c;
}

.btn-primary:hover {
  background: #911515;
  border-color: #911515;
  transform: translateY(-2px);
}

.btn-outline {
  background: transparent;
  color: #111;
  border: 2px solid #d4d4d4;
}

.btn-outline:hover {
  border-color: #b91c1c;
  color: #b91c1c;
}

.notfound-links {
  margin-top: 55px;
  padding-top: 30px;
  border-top: 1px solid #e5e5e5;
}

.links-label {
  font-size: 0.78rem;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: #888;
  font-weight: 700;
  margin: 0 0 14px;
}

.notfound-links ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  gap: 28px;
  justify-content: center;
  flex-wrap: wrap;
}

.notfound-links a {
  color: #444;
  text-decoration: none;
  font-weight: 600;
  border-bottom: 1px solid transparent;
  padding-bottom: 2px;
  transition: all 0.25s ease;
}

.notfound-links a:hover {
  color: #b91c1c;
  border-bottom-color: #b91c1c;
}

@media (max-width: 520px) {
  .notfound-actions {
    flex-direction: column;
  }

  .btn-primary,
  .btn-outline {
    width: 100%;
    box-sizing: border-box;
  }

  .notfound-links ul {
    gap: 16px;
  }
}
</style>
